export default __webpack_public_path__ + "static/media/fecha-de-toma.5bdf25dd.svg";